import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    Card,
    ChevronUpIcon,
    GridItem,
    Image,
    ImageCaption,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './EditorialCards.scss';

function ButtonText({ t, namespace }) {
    return (
        <>
            <span>{t(`${namespace}:blogReadMore`)}</span>
            <ChevronUpIcon className={styles.chevron} />
        </>
    );
}

const LocalizedButtonText = localize(ButtonText);

function LinkTitle({ href, title }) {
    return (
        <A
            href={href}
            target="_blank"
            underline="none"
            variant="subdued"
        >
            {title}
        </A>
    );
}

function ImageLink(props) {
    const {
        url,
        metadata,
        captionTitle,
        captionLicense,
        ...otherProps
    } = props;
    const imageComponent = (
        <Image
            captionLicense={captionLicense}
            captionTitle={captionTitle}
            className={styles.cityImage}
            height={192}
            loading="lazy"
            metadata={metadata}
            width={343}
            {...otherProps}
        />
    );

    if (url) {
        return (
            <A
                className={styles.imageLink}
                href={url}
                target="_blank"
                underline="none"
            >
                {imageComponent}
            </A>
        );
    }

    return imageComponent;
}

function EditorialCards(props) {
    const {
        t,
        namespace,
        imageObj = {},
    } = props;
    const {
        src,
        alt,
        metadata = {},
        title = '',
        url = '',
    } = imageObj;
    const {
        alt: metaAlt,
    } = metadata;

    const body = url
        ? <LinkTitle href={url} title={title} />
        : title;

    const buttonText = title
        ? <LocalizedButtonText namespace={namespace} />
        : '';

    return (
        <Card
            body={body}
            buttonProps={{
                variant: 'text',
                href: url,
                target: '_blank',
            }}
            buttonText={buttonText}
            component={GridItem}
            componentProps={{
                xs: 12,
                md: 4,
                align: 'start',
                justify: 'start',
            }}
            imageComponent={(
                <ImageLink
                    alt={alt || metaAlt}
                    captionLicense={t(`${namespace}:stationImageLicense`)}
                    captionTitle={t(`${namespace}:stationImageCredit`)}
                    loading="lazy"
                    metadata={metadata}
                    src={src}
                    url={url}
                />
            )}
            variant="floating"
        />
    );
}

EditorialCards.propTypes = {
    namespace: PropTypes.string.isRequired,
    imageObj: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
        author: PropTypes.string,
        license: PropTypes.string,
        title: PropTypes.string,
    }).isRequired,
};

export {
    ButtonText,
    EditorialCards,
    ImageLink,
    LinkTitle,
};
export default localize(EditorialCards);
